/**
 * HistopathologyConfigHome.js – Masters / Settings home (migrated from admin4.0).
 * Functional component; same flow and design as reference. Uses useNavigate (v6).
 */
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { ClickableCard } from "../../Components/Common Components/DashboardComponents";
import ImagePaths from "../../Utility/ImagePaths";
import { Colors } from "../../Styles/Colors";
import { getCachevalue } from "../../Utility/Services/CacheProviderService";
import { canViewTab } from "../../Utility/Services/RoleAccessService";
import "../../Styles/Configuration.css";

/** Settings main_tabs aligned with AddRoleAccess.js (Service Master, Result Template, …). */
const SETTINGS_TABS = [
  { id: 0, sub_title: "Service Master", value: "serviceMaster", path: "/HistopathologySetting/MasterConfiguration/ServiceMaster", icon: ImagePaths.Histopathology?.default ?? ImagePaths.Histopathology },
  { id: 1, sub_title: "Result Template", value: "resultTemplate", path: "/HistopathologySetting/MasterConfiguration/ResultTemplate", icon: ImagePaths.Histopathology?.default ?? ImagePaths.Histopathology },
  { id: 2, sub_title: "Specimen Master", value: "specimenMaster", path: "/HistopathologySetting/MasterConfiguration/SpecimenMaster", icon: ImagePaths.Histopathology?.default ?? ImagePaths.Histopathology },
  { id: 3, sub_title: "Demographics Layout", value: "demographicsConfig", path: "/HistopathologySetting/ClinicConfiguration/DemographicsLayout", icon: ImagePaths.demographicConfig?.default ?? ImagePaths.demographicConfig },
  { id: 4, sub_title: "Outsource Configuration", value: "outsourceConfig", path: "/HistopathologySetting/ClinicConfiguration/OutSourceConfiguration", icon: ImagePaths.demographicConfig?.default ?? ImagePaths.demographicConfig },
  { id: 5, sub_title: "E-Sign Configuration", value: "eSignConfig", path: "/HistopathologySetting/ClinicConfiguration/eSignConfiguration", icon: ImagePaths.demographicConfig?.default ?? ImagePaths.demographicConfig },
  { id: 6, sub_title: "Referred Doctor", value: "referredDoctor", path: "/HistopathologySetting/ClinicConfiguration/ReferredDoctor", icon: ImagePaths.demographicConfig?.default ?? ImagePaths.demographicConfig },
  { id: 7, sub_title: "Custom Configuration", value: "customConfig", path: "/HistopathologySetting/ClinicConfiguration/CustomConfiguration", icon: ImagePaths.demographicConfig?.default ?? ImagePaths.demographicConfig },
  { id: 8, sub_title: "Hospital Configuration", value: "corporateConfig", path: "/HistopathologySetting/ClinicConfiguration/CorporateConfiguration", icon: ImagePaths.demographicConfig?.default ?? ImagePaths.demographicConfig },
  { id: 9, sub_title: "Role Access", value: "roleAccess", path: "/HistopathologySetting/UserConfiguration/RoleAccess", icon: ImagePaths.userConfig?.default ?? ImagePaths.userConfig },
  { id: 10, sub_title: "User Configuration", value: "userConfig", path: "/HistopathologySetting/UserConfiguration/UserConfig", icon: ImagePaths.userConfig?.default ?? ImagePaths.userConfig },
];

export default function HistopathologyConfigHome() {
  const navigate = useNavigate();
  const [selectedConfigScreen, setSelectedConfigScreen] = useState("");
  const [isSelected, setIsSelected] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    // User data on mount (for any future role/sms logic)
    JSON.parse(getCachevalue("loggedInUserInfo") || "{}");
  }, []);

  const handleConfigNavigation = useCallback(
    (id, item) => {
      setIsSelected(true);
      setSelectedIndex(id ?? null);
      setSelectedConfigScreen(item?.value ?? "");
      if (item?.path) {
        navigate(item.path);
      }
    },
    [navigate]
  );

  const visibleTabs = SETTINGS_TABS.filter((sub) => canViewTab(sub.sub_title));

  return (
    <Box
      component="div"
      className="eMed_Config_Wrapper"
      style={{ backgroundColor: Colors.configHomeBg }}
    >
      <Box component="div" className="eMed_Config_Div">
        {visibleTabs.length > 0 && (
          <Typography id="eMed_Config_header">Histopathology Configuration</Typography>
        )}
        <Box component="div" display="flex" flexWrap="wrap">
          {visibleTabs.map((sub) => (
            <Box component="div" key={sub.id} id="eMed_Config_mainDiv">
              <ClickableCard
                label={sub.sub_title}
                icon={sub.icon}
                width="4vw"
                height="4vw"
                isSelected={isSelected && selectedIndex === sub.id}
                onClick={() => handleConfigNavigation(sub.id, sub)}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
